import React from "react";
import { Link, NavLink } from "react-router-dom";

import "./Footer.css";

import {
  FaFacebookF,
  FaInstagram,
  FaWhatsapp,
  FaLinkedinIn,
} from "react-icons/fa6";
import logo from "../../Image/logo.png";
const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Logo Section */}
        <div className="footer-col logo-col">
          <div className="Footer_logo">
            <Link to="/" className="Footer_logo-link">
              <img src={logo} alt="logo" />
              <span className="Footer_logo-text">JALA-E-BIKES</span>
              <p>A RETAIL SHOP</p>
            </Link>
          </div>
        </div>

        {/* About */}

        {/* Scooter */}
        <div className="footer-col">
          <h4>SCOOTER</h4>
          <ul>
            <li>NOVA</li>
            <li>NOVA-S</li>
            <li>NOVA-X</li>
            <li>CRX</li>
            <li>EDGE</li>
            <li>EDGE+</li>
            <li>NEO</li>
          </ul>
        </div>

        {/* Policy */}
        <div className="footer-col">
          <h4>POLICY</h4>
          <ul>
            <li>
              <NavLink
                to="/privacy-policy"
                className="footer-link"
                activeClassName="active-footer-link"
              >
                Privacy policy
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/terms_conditions"
                className="footer-link"
                activeClassName="active-footer-link"
              >
                Terms & Conditions
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/Refund_Cancellations"
                className="footer-link"
                activeClassName="active-footer-link"
              >
                Refund & Cancellations
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/Shipping_policy"
                className="footer-link"
                activeClassName="active-footer-link"
              >
                Shipping policy
              </NavLink>
            </li>
          </ul>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="footer-bottom">
        <div className="line"></div>

        <div className="socials">
          <a
            href="https://www.facebook.com/profile.php?id=100095550450730&mibextid=wwXIfr&rdid=shG86gF7uwG7JU26&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F17hM7PEWbu%2F%3Fmibextid%3DwwXIfr#"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaFacebookF />
          </a>
          <a
            href="https://www.instagram.com/ujala_e_mobility_pvt_ltd_?igsh=MWt5bGd4cm16aHV3Zw%3D%3D&utm_source=qr"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaInstagram />
          </a>
          <a
            href="https://wa.me/8009539867"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaWhatsapp />
          </a>
          <FaLinkedinIn />
        </div>
      </div>
    </footer>
  );
};

export default Footer;
